/* eslint-disable react/prop-types */
import classes from "./partners.module.scss";

import listsFile from "@/static-texts/lists.json";
import Flex from "@/components-library/layout/flex";
import ComposedViewHeader from "@/composed-views/composed-view-header";
import CardPartner from "@/composed-views/card-partner";
import GridList from "@/components-library/widgets/grid-list";
function Partners({ content: partners }) {
  const partnersList = listsFile.partners;
  const itemComponent = <CardPartner />;
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Flex
      align="flex-start"
      className={classes.partners}
      direction="column"
      justify="flex-start"
    >
      <ComposedViewHeader
        header={partners.header.header}
        title={partners.header.title}
        subTitle={partners.header.subTitle}
      />

      <GridList
        columns={isMobile ? 1 : 3}
        items={partnersList}
        itemComponent={itemComponent}
        className={classes.container}
      />
    </Flex>
  );
}

export default Partners;
